import {IconContainer} from '@jobseeker/lotus/components/MediaRecorder/common';
import {useIsLargeDevice} from '@jobseeker/lotus/hooks';
import {Box} from '@mui/material';
import {useState} from 'react';
import {FaPause, FaPlay} from 'react-icons/fa';
import dynamic from 'next/dynamic';
import Loader from '@jobseeker/lotus/components/Loader';

const ReactPlayer = dynamic(() => import('react-player'), {
  ssr: false,
  loading: () => <Loader />,
});

export const VideoPlayer = ({url, sx = {}, ...props}: any) => {
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const isLarge = useIsLargeDevice();

  const togglePlayback = () => {
    setIsVideoPlaying(!isVideoPlaying);
  };
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        position: 'relative',
        borderRadius: 4,
        overflow: 'hidden',
        ...(isVideoPlaying
          ? {
              '& > .playIcon': {
                opacity: 0,
              },
              ':hover': {
                '& > .playIcon': {
                  opacity: 1,
                },
              },
            }
          : {}),
      }}
    >
      <ReactPlayer
        // component={ReactPlayer}
        url={url}
        width="100%"
        height="100%"
        objectFit="cover"
        style={{
          backgroundColor: '#000',
          width: '100%',
          maxWidth: '100%',
          height: '100%',
          maxHeight: '100%',
          ...sx,
        }}
        playsinline={true}
        pip={false}
        disablePictureInPicture
        controls={!isLarge}
        onEnded={() => setIsVideoPlaying(false)}
        playing={isLarge ? isVideoPlaying : undefined}
        {...props}
      />
      {isLarge && (
        <IconContainer className="playIcon" onClick={togglePlayback}>
          <Box lineHeight={0}>{isVideoPlaying ? <FaPause /> : <FaPlay />}</Box>
        </IconContainer>
      )}
    </Box>
  );
};

export default VideoPlayer;
